import { render, staticRenderFns } from "./SelectCategoria.vue?vue&type=template&id=cfe03988"
import script from "./SelectCategoria.vue?vue&type=script&lang=js"
export * from "./SelectCategoria.vue?vue&type=script&lang=js"
import style0 from "./SelectCategoria.vue?vue&type=style&index=0&id=cfe03988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports